export const getAbbreviation = (text: string): string => {
  return text
    .split(" ")
    .filter((word) => word.length > 0) // Handle extra spaces
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};
